export const FEEDBACK_OPTIONS = [
  {
    value: 'SKILLS_AND_SERVICES',
    translationKey: 'caregiverDetail.CaregiverFeedback.FeedbackOptions.SkillsAndServices',
  },
  {
    value: 'EXPERIENCE',
    translationKey: 'caregiverDetail.CaregiverFeedback.FeedbackOptions.Experience',
  },
  {
    value: 'LANGUAGE',
    translationKey: 'caregiverDetail.CaregiverFeedback.FeedbackOptions.Language',
  },
  {
    value: 'LOCATION',
    translationKey: 'caregiverDetail.CaregiverFeedback.FeedbackOptions.Location',
  },
  {
    value: 'CREDENTIALS',
    translationKey: 'caregiverDetail.CaregiverFeedback.FeedbackOptions.Credentials',
  },
  {
    value: 'PERSONALITY',
    translationKey: 'caregiverDetail.CaregiverFeedback.FeedbackOptions.Personality',
  },
  {
    value: 'OTHER',
    translationKey: 'caregiverDetail.CaregiverFeedback.FeedbackOptions.Other',
  },
];
